/*global is_search_panel_float */
import locales from '@/locales/locales'
import { ExportTimestampKey } from '@/constants/global_variables'
import mathUtil from '@/utils/math_util'

const expire_date = process.env.VUE_APP_EXPIRE_DATE
const release_date = process.env.VUE_APP_RELEASE_DATE

export default {
  data() {
    return {
      env: process.env, // 环境变量
      apiUri: process.env.VUE_APP_API_URI, // API 地址
      themeColors: {
        green: '#41C981',
        blue: '#0A6ED9',
        brown: '#E19853',
        indigo: '#5571A9',
        purple: '#AA607F'
      },
      instance: this // :search-condition-component="this" 不能直接使用 this，提示“Property "__ob__" must be accessed with "$data.__ob__" because properties starting with "$" or "_" are not proxied in the Vue instance to prevent conflicts with Vue internals”
    }
  },
  computed: {
    currentTheme() {
      return localStorage.getItem('theme') || 'green'
    }
  },
  methods: {
    checkLifecycle() {
      let current_time = this.$moment()
      if (current_time.isAfter(this.$moment(expire_date)) && current_time.isBefore(this.$moment(release_date))) {
        this.$alert(
          '管理员您好，管理平台将在2021年8月1日到期，平台过期后将在7天后自动释放，释放后将导致服务不可用，为避免影响正常业务运行，请于2021年8月8日前完成充值，谢谢。',
          '提示！',
          {
            confirmButtonText: '确定'
          }
        )
      }
    },
    /**
     * 表格头单元格样式
     *
     * @returns {object} style object
     */
    tableHeaderCellStyle() {
      return { background: '#f5f7fa' }
    },
    /**
     * 单元格样式
     * https://github.com/ElementUI/theme-chalk/blob/master/src/table.scss
     *
     * @returns {object} style object
     */
    tableCellStyle() {
      return { verticalAlign: 'top', fontSize: '13px' }
    },
    /**
     * 跳转到指定的路由地址
     *
     * @param {string} uri 路由地址
     */
    routerTo(uri) {
      this.$router.push(uri)
    },
    goback(url) {
      if (history.length <= 2) {
        this.$router.push('/' + url)
      } else {
        this.$router.go(-1)
      }
    },
    isEmptyObject(obj) {
      for (let name in obj) {
        return false
      }

      if (typeof obj === 'number' || typeof obj === 'boolean') return false // 如果是数值 或者布尔值，都不能认为是空
      return true
    },
    filterByTime(data, filter, table) {
      var component_table
      var fields = {}
      this.$nextTick(function() {
        $.each(this.$refs, function(i, n) {
          if (i.match(table)) {
            component_table = n
          }
        })
        fields['date_type'] = data.date_type
        fields[filter + '[begin]'] = data.time_range.begin
        fields[filter + '[end]'] = data.time_range.end
        component_table.filterFields(fields)
      })
    },
    localeKeys: function(path) {
      var obj = this.localeObject(path)
      return Object.keys(obj)
    },
    localeObject: function(path) {
      var paths = path.split('.')
      var obj = locales[this._i18n.locale]
      for (var i = 0; i < paths.length; i++) {
        obj = obj[paths[i]]
      }
      return obj
    },
    scrollPageToolbar: function() {
      var pageElem = $(this.$el)
      var pageId = $(pageElem).attr('id')
      $('#content').scroll(function() {
        var dom = $('#' + pageId + ' .page-body').width()
        if (dom > 0) {
          var height = $('#' + pageId + ' .page-body').offset().top
          if (height < 48) {
            $('#' + pageId + ' .page-body .page-toolbar>div').addClass('page-top-float')
            $('#' + pageId + ' .page-body .page-toolbar>div').width($('#' + pageId + ' .page-body').width())
          } else {
            $('#' + pageId + ' .page-body .page-toolbar>div').removeClass('page-top-float')
            $('#' + pageId + ' .page-body .page-toolbar>div').css('width', 'auto')
          }
        }
      })
    },
    /**
     * 按千分号格式化数字
     *
     * @param {number} number 数值
     * @param {number} minimumFractionDigits 小数点后至少要显示多少位
     * @param {number} maximumFractionDigits 小数点后最多要显示多少位
     * @returns {string} 格式化后的数值
     */
    formatThousands: function(number = 0, minimumFractionDigits = 0, maximumFractionDigits = 2) {
      number = typeof number == 'string' ? parseFloat(number) : number
      return number.toLocaleString('en-US', { minimumFractionDigits, maximumFractionDigits })
    },
    /**
     * 格式化数字，转换为带万、亿等单位的易读字符串
     *
     * @param {number} value 数字
     * @returns {string} 格式化后的数字
     */
    tenThousandFormat(value) {
      if (value == null || value === '' || typeof value == 'undefined') {
        return '-'
      }
      var formatValue = 0
      var unit = '' // 空/万
      var k = 10000,
        size = ['', '万', '亿', '万亿'],
        i
      if (value < k) {
        formatValue = value
        unit = ''
      } else {
        i = Math.floor(Math.log(value) / Math.log(k))
        formatValue = (value / Math.pow(k, i)).toFixed(2)
        unit = size[i]
      }
      return this.num(formatValue) + unit
    },
    /**
     * 按千分号格式化数字
     *
     * @param {number} number 数值
     * @returns {string} 格式化后的数值
     */
    num(number = 0) {
      return this.formatThousands(number)
    },
    isSearchPanelFloat() {
      return is_search_panel_float
    },
    /**
     * 同一账号多人登录，保证只有当前客户端会自动下载
     * 一个客户端开了多个 tab 标签页面，保证只下载一次
     *
     * @param {string} exportType 当前导出的标记，主要用于记录当前导出的的状态
     *  'orders' | 'top_ups' | 'chargers' | ...
     * @param {object} params
     *   { keyword: 'xxx', status: 'done', ... }
     * @returns {object} 导出参数
     */
    buildExportParams(exportType, params) {
      let timestamp = Date.parse(moment())
      // 请求的唯一标识，通过 sessionStorage 保存到当前标签页；
      // 当成功后，后台通知的时候会返回 export_timestamp_key，只有保存有该 key 的标签页才发起下载
      sessionStorage.setItem(exportType + ExportTimestampKey, timestamp)
      let newParams = Object.assign({ export_timestamp_key: timestamp }, params)

      return newParams
    },
    /**
     * 获取运营商列表(tree 结构)
     *
     * @param {string} topServiceProviderId 顶部的运营商ID
     * @returns {Array<object>} 运营商树
     */
    fetchServiceProviderTree(topServiceProviderId) {
      let serviceProviderId = topServiceProviderId ? topServiceProviderId : this.$store.state.app.currentServiceProvider.id
      return this.$http.get(`/backend/service_providers/${serviceProviderId}/options`).then(response => {
        return [this.serviceProviders2TreeOptions(serviceProviderId, response.data)]
      })
    },
    /**
     * 运营商列表转化为 tree 组件可用的 options
     *
     * @param {string} serviceProviderId 当前要构建的层级的运营商，会找出该层级并设置他的子运营商
     * @param {Array} serviceProviderOptions { id, name, parent_id, children_count }
     * @returns {Array} 运营商选项
     */
    serviceProviders2TreeOptions(serviceProviderId, serviceProviderOptions) {
      let serviceProvider = serviceProviderOptions.find(sp => sp.id === serviceProviderId)
      let option = {
        id: serviceProvider.id,
        label: serviceProvider.name,
        isDefaultExpanded: true,
        charge_stations_count: serviceProvider.charge_stations_count
      }

      if (serviceProvider.children_count > 0) {
        let children = serviceProviderOptions.filter(sp => sp.parent_id === serviceProvider.id)
        option.children = children.map(child => {
          return this.serviceProviders2TreeOptions(child.id, serviceProviderOptions)
        })
      }

      return option
    },
    /**
     * 开发环境的log信息
     *
     * @param {...object} args console log 对应的信息
     */
    debug(...args) {
      if (process.env.NODE_ENV === 'development') {
        let logs = [moment().format('HH:mm:ss'), ...args]
        console.log(...logs)
      }
    },
    /**
     * 如果没有后退的路径，则跳转到指定的路径。并且不保留本次页面的历史路由记录。
     *
     * @param {string} path 跳转的路径
     */
    backOrReplaceRouter(path) {
      if (history.length <= 2) {
        this.$router.replace(path)
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 时间格式化显示
     *
     * @param {string} isoTime ISO 格式的时间字符串
     * @returns {string} YYYY-MM-DD HH:mm:ss 格式的时间
     */
    formatTime(isoTime) {
      if (isoTime == null || isoTime == '' || typeof isoTime == 'undefined') {
        return '-'
      } else {
        return moment(isoTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
      }
    },
    /**
     * 显示值内容，如果缺省一般用 - 代替
     *
     * @param {string} text 要显示的文字
     * @param {string} nullDisplay 缺省的时候显示的文字
     * @returns {string} 返回要显示的内容
     */
    displayText(text, nullDisplay = '-') {
      if (text === '' || text === null || text === undefined) {
        return nullDisplay
      }
      return text
    },
    /**
     * 显示值内容，如果缺省一般用 - 代替
     *
     * @param {string} text 要显示的文字
     * @param {string} nullDisplay 缺省的时候显示的文字
     * @returns {string} 返回要显示的内容
     */
    txt(text, nullDisplay = '-') {
      return this.displayText(text, nullDisplay)
    },
    /**
     * 显示值内容，如果缺省一般用 - 代替
     * 格式化，并且加货币
     *
     * @param {number} number 数值
     * @param {number} maximumFractionDigits 小数点后最多要显示多少位
     * @param {number} minimumFractionDigits 小数点后至少要显示多少位
     * @param {string} nullDisplay 缺省的时候显示的文字
     * @returns {string} 返回要显示的内容
     */
    money(number, maximumFractionDigits = 2, minimumFractionDigits = 0, nullDisplay = '-') {
      if (this.isEmptyObject(number)) {
        return nullDisplay
      }
      return this.$t('common.unit.currency') + this.formatThousands(number, minimumFractionDigits, maximumFractionDigits)
    },
    /**
     * 显示百分比
     *
     * @param {number} decimal 数值
     * @returns {string} 返回要显示的内容
     */
    percent(decimal) {
      return decimal ? `${mathUtil.multiply(decimal, 100)}%` : '-'
    },
    /**
     * uri 增加参数
     *
     * @param {string} uri 地址
     * @param {object} params 参数
     * @returns {string} 增加参数后的uri
     */
    uriAppendParams(uri, params) {
      if (params) {
        let paramsStr = new URLSearchParams(params).toString()
        return uri.includes('?') ? `${uri}&${paramsStr}` : `${uri}?${paramsStr}`
      }
      return uri
    },
    /**
     * 电站的跳转地址
     *
     * @param {object} evChargingStation 充电站
     * @returns {string} URL
     */
    evChargingStationRouter(evChargingStation) {
      switch (evChargingStation.stationable_type) {
        case 'ChargeStation':
          return `/charge_stations/${evChargingStation.stationable_id}/detail`
        case 'EvcsStation':
          return `/evcs_stations/${evChargingStation.stationable_id}/detail`
      }

      return `/ev_charging_stations/${evChargingStation.stationable_id}/detail`
    },
    /**
     * 电桩的跳转地址
     *
     * @param {object} evChargingPile 充电桩
     * @returns {string} URL
     */
    evChargingPileRouter(evChargingPile) {
      return `/charge_points/${evChargingPile.source_id}/detail`
    },
    /**
     * 电枪的跳转地址
     *
     * @param {object} evChargingGun 充电枪
     * @returns {string} URL
     */
    evChargingGunRouter(evChargingGun) {
      switch (evChargingGun.source_type) {
        case 'Charger':
          return `/chargers/${evChargingGun.source_id}/detail`
        case 'EvcsConnector':
          return `/evcs_connectors/${evChargingGun.source_id}/detail`
      }

      return '/'
    },
    /**
     * 充电站的简称
     *
     * @param {string} stationName 充电站完成名称
     * @returns {string} 名称
     */
    stationShortName(stationName) {
      if (this.isEmptyObject(stationName)) return '-'

      return stationName
        .replace('小可乐', '')
        .replace('充电站', '')
        .replace('超级', '')
        .replace('智能', '')
        .replace('停车场', '')
        .replace('商城', '')
        .replace('商城', '')
        .replace('广场', '')
        .replace('商业', '')
        .replace('中心', '')
    },
    /**
     * 通知全局的刷新
     * 其他通过监听并响应 refreshTs 的变化主动更新
     */
    refreshNotify() {
      this.$store.dispatch('app/updateRefreshTs') // 通知全局刷新
    },
    /**
     * 固定宽度的数字显示，不足时后面补空格
     * 用于 tab 标签页显示数量占位使用，避免数字异步更新后 tab 宽度跳动导致 active tab 下划线跳动
     *
     * @param {number|string} number 数字
     * @param {number} length 固定长度
     * @returns {string} 固定长度的字符串
     */
    fixedNum(number, length = 3) {
      if (this.isEmptyObject(number)) number = 0

      let str = String(number)
      while (str.length < length) {
        str = str + '-'
      }
      str = str.replaceAll('-', '  ') // 一个空格比数字窄
      return str
    }
  }
}
